import { Swiper, Navigation, Pagination, Keyboard } from "swiper/swiper.esm";

export const swiperParams = {
  Swiper,
  modules: [Navigation, Pagination, Keyboard],
  slidesPerView: "auto",
  loop: true,
  spaceBetween: 24,
  breakpoints: {
    768: {
      spaceBetween: 30
    }
  },
  preloadImages: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    renderBullet: function(_, className) {
      return `<span class="${className}"><span class="custom-bullet"></span></span>`;
    }
  },
  threshold: 10,
  keyboard: {
    enabled: true,
    onlyInViewport: true
  },
  navigation: {
    nextEl: ".swiper-button-next"
  },
  rtl: true
};

export const swiperParamsOneSlide = {
  Swiper,
  modules: [Navigation, Pagination, Keyboard],
  slidesPerView: "1",
  loop: false,
  spaceBetween: 24,
  breakpoints: {
    768: {
      spaceBetween: 30
    }
  },
  watchOverflow: true,
  preloadImages: true,
  pagination: {
    el: ".swiper-pagination.disabled",
    clickable: false,
    renderBullet: function(_, className) {
      return `<span class="${className}"><span class="custom-bullet"></span></span>`;
    }
  },
  threshold: 10,
  keyboard: {
    enabled: true,
    onlyInViewport: true
  },
  navigation: {
    prevEl: ".swiper-button-disabled",
    nextEl: ".swiper-button-disabled",
    disabledClass: ".swiper-button-disabled"
  },
  rtl: true,
  allowSlidePrev: false,
  allowSlideNext: false
};
